/* eslint-disable no-unused-vars */
import {
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Grid,
	TextField,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import FXCMTrans from "../../components/common/FXCMTrans";
import Header from "../../components/layout/Header";
import { configurationServices } from "../../constants/configurationServices";
import { password } from "../../constants/ImageConstants";
import { useDispatch, useSelector } from "react-redux";
import { analytics } from "../../utils/analytics/analytics";
import useDirectionHook from "../../hooks/useDirectionHook";
import { notifyApiFail } from "../../reducers/errorNotifySlice";
import { getAPIPath } from "../../utils/endPointMapper";
import { customAxios } from "../../services/serviceInterceptor";
import { systemAlertFunc } from "../../services/auth.service";
import { getRequestHeaders } from "../../utils/getUsersDetails";
import {CUSTOM_EMAIL} from "../../utils/regex";
import DOMPurify from 'dompurify';
import { resolveCountryBlockedMessage, isCountryBlockedResponse } from "../../utils/countryBlocked";
const appURL = getAPIPath().REACT_APP_URL;

/* istanbul ignore next */
const ForgotPassword = () => {//NOSONAR
	const { t: getLabel } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [fxcmError, setFxcmError] = useState(false);
	const [error, setError] = useState({
		email: false,
		username: false,
	});
	const [forgotPass, setforgotPass] = useState(false);
	// CX-51004: country-of-residence block (CX-51003), shown inline and persistently.
	// A flag, not the resolved copy — storing the string would freeze it in the
	// language active at block time and it would not follow a language switch.
	const [countryBlocked, setCountryBlocked] = useState(false);
	// CX-51021: country code for COUNTRY_BLOCKED_MESSAGE_N bucket routing —
	// captured from the BE error payload the same way ForgotUsername.js does.
	const [blockedCountryCode, setBlockedCountryCode] = useState(null);
	// CX-51004/CX-51021: resolved async (cross-entity aware — see countryBlocked.js),
	// not at render, since the correct entity's bundle now has to be fetched
	// directly rather than read off the currently loaded i18next instance.
	const [countryBlockedMessage, setCountryBlockedMessage] = useState(null);
	const [link, setLink] = useState();
	const[buttonLoader, setButtonLoader] = useState(false);


	const [values, setValues] = useState({
		email: "",
		username: "",
		isChecked: false,
	});

	const [mandatoryError, setmandatoryError] = useState({
		email: false,
		username: false,
	});
	const [forgotPasswordError] = useState();
	const { languageParam, getAllEnLabels} = useSelector((state) => state.signUp);
	const [config, setConfig] = useState();
	const [isEmailExist,setIsEmailExist] = useState(false);
	// CX-51004: COUNTRY_BLOCKED_MESSAGE_N bucket routing needs the same
	// restrictedCountries.json config SignUpForm.js already loads.
	const [restrictedCountriesList, setRestrictedCountriesList] = useState();
	const [direction] = useDirectionHook(languageParam) //custom hook

	const fetchJson = () => {
		fetch(configurationServices().LogInURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setConfig(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};
	useEffect(() => {
		fetchJson();
	}, []);

	const fetchFxcmRestrictedCountriesJson = () => {
		fetch(configurationServices().restrictedCountriesURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setRestrictedCountriesList(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};
	useEffect(() => {
		fetchFxcmRestrictedCountriesJson();
	}, []);

	const defaultLocale = DOMPurify.sanitize(localStorage.getItem("i18nextLng"));
	const fetchSupportLinkJson = () => {
		fetch(configurationServices().supportLinks)
			.then((res) => {
				return res.json();
			})
			.then((data) => {
			const localeToUse = languageParam || defaultLocale;
				 const filteredDenominationArray = data?.SUPPORT_LINK?.filter((value) => value.locale === localeToUse);
					setLink(filteredDenominationArray[0]?.link)
			})
			.catch((e) => {
				console.log(e.message);
			});
	};


  useEffect(() => {
		fetchSupportLinkJson();
	}, [languageParam]);

	// CX-51004/CX-51021: resolves the block copy from the blocked country's
	// OWNING entity bundle (see countryBlocked.js) rather than whatever entity
	// i18next currently has loaded. Re-runs on languageParam so a language
	// switch after the block still re-translates this message.
	useEffect(() => {
		let cancelled = false;
		if (countryBlocked && blockedCountryCode) {
			resolveCountryBlockedMessage(getLabel, blockedCountryCode, restrictedCountriesList, languageParam).then(
				(message) => {
					if (!cancelled) setCountryBlockedMessage(message);
				}
			);
		} else {
			setCountryBlockedMessage(null);
		}
		return () => {
			cancelled = true;
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countryBlocked, blockedCountryCode, restrictedCountriesList, languageParam]);

	useEffect(() => {
		if (forgotPass) {
				analytics?.trackEvent("forgot_password", {});
				navigate("/forgotpasswordConfirm", { state: { email: values.email,success:isEmailExist } });
		}
	}, [forgotPass, dispatch, navigate, values]);

	const emailRegex = CUSTOM_EMAIL.test(values.email);


		

	const handleChange = (prop) => (event) => {
		if (prop === "username") {
			setmandatoryError({ ...error, username: false });
		}

		if(prop === "username") {
            if(event.target.value === "" ) {
				setmandatoryError({ ...error, username: true });
				setError({ ...error, username: true });
			} else if(event.target.value.length > 0) {
				setmandatoryError({ ...error, username: false });
				setError({ ...error, username: false });
			}
		}

		setFxcmError(false);
		setValues({ ...values, [prop]: event.target.value });
		if (
			event.target.value.includes("fuhui") ||
			event.target.value.includes("fxcm")
		) {
			setError({ ...error, email: true });
			setFxcmError(true);
		} else {
			setFxcmError(false);
		}
	};

	const handleBlurEmail = () => {
		setmandatoryError({
			...error,
			email: false,
			username: false,
		});
		if (emailRegex) {
			setError({ ...error, email: false });
		} else {
			setError({ ...error, email: true });
		}
	};


	const handleBlurUsername = () => {

		setmandatoryError({
			...error,
			email: false,
			username: false,
		});
		
		if(values.username === "") {
			setmandatoryError({ ...error, username: true });
			setError({ ...error, username: true });
		}
	}


	const handleLabelChange = (e) => {
        const updatedChecked = !values.isChecked;
        const updatedUsername = updatedChecked ? values.email : "";
   
        setValues({
            ...values,
            isChecked: updatedChecked,
            username: updatedUsername,
        });
   
        if (updatedChecked && values.email) {
            setError({ ...error, username: false });
            setmandatoryError({ ...mandatoryError, username: false });
        }
    };

	const handleCancelClick = () => {
		analytics?.trackEvent("targeted_click", { engagementContext: getAllEnLabels["CANCEL"] });
		navigate("/login");
	};

	const validation = () => {
		let isValid = true;
		if (error.username || error.email) {
			isValid = false;
		}
		if (values.email === "" || values.username === "") {
			isValid = false;
		}
		return isValid;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		let emailError = false;
		let usernameError = false;

		if (values.email === "") {
			emailError = true;
		} 
		if (values.username === "") {
			usernameError = true;
		}
		
		setError({
			...error,
			email: emailError,
			username: usernameError,
		});

		setmandatoryError({
			...error,
			email: emailError,
			username: usernameError,
		});

		if (validation()) {
			setButtonLoader(true);
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
			setValues({ ...values });

			const requestParams = {
				email: values.email,
				username: values.username,
				domainName: window.location.origin
			};
			const requestObj = {
				processName: "resetPassword",
				requestBody: requestParams,
				methodType: "POST",
			};
			const config = {
				...getRequestHeaders()
			};
			customAxios
				.post(appURL + "/resetpassword", requestObj, config)
				.then((response) => {
					if(response.data.httpStatus === "SERVICE_UNAVAILABLE"){
						dispatch(notifyApiFail({title: getLabel("SERVICE_UNAVAILABLE"),
						desc: getLabel("SERVICE_UNAVAILABLE"),
						type: "Failed",},
						));
						dispatch(systemAlertFunc(config?.headers?.requestid, response?.data?.type, response?.data?.message));
						
					}
					else{
						setIsEmailExist(response.data.success);
						setforgotPass(true);
					}
					setButtonLoader(false);
					// CX-51023: a prior COUNTRY_BLOCKED submit leaves this true forever
					// otherwise — the banner would keep showing even after a later
					// successful submit (mirrors Login.js's equivalent reset).
					setCountryBlocked(false);
					setBlockedCountryCode(null);
				})
				.catch((err) => {
					// CX-51004: country-of-residence block (CX-51003) returns 401 with
					// message "COUNTRY_BLOCKED". Distinguish it from a genuine outage —
					// reporting it as SERVICE_UNAVAILABLE would be wrong for the user and
					// would raise a false system alert.
					if (isCountryBlockedResponse(err?.response?.data)) {
						// Inline, not notifyApiFail: FXCMErrorNotification auto-dismisses
						// after 10s and a regulatory blocking notice must not vanish while
						// the user is reading it.
						setCountryBlocked(true);
						setBlockedCountryCode(err?.response?.data?.additionalProperties?.countryOfResidence);
						setButtonLoader(false);
						return;
					}

					dispatch(notifyApiFail({title: getLabel("SERVICE_UNAVAILABLE"),
					desc: getLabel("SERVICE_UNAVAILABLE"),
					type: "Failed",},
					));
					dispatch(systemAlertFunc(config?.headers?.requestid, err?.type, err?.message));
					// CX-51023: same reset as the success branch above — a prior block
					// must not keep showing once a later, differently-shaped response
					// comes back.
					setCountryBlocked(false);
					setBlockedCountryCode(null);
					setButtonLoader(false);

				});
		}
	};

	let enabled = !(emailRegex && values.email !== "" && values.username !== "");

	let formControlClass = "custom-form-controler";

	if (direction.status) {
	formControlClass = forgotPasswordError
		? "custom-form-controler-error custom_form_controler_arabic"
		: "custom-form-controler custom_form_controler_arabic";
	}

	let helperText = "";

	if (error.email) {
		if (fxcmError) {
			helperText = getLabel(config?.EmailFXCMERROR);
		} else if (mandatoryError.email) {
			helperText = getLabel(config?.MANDATORY_CHECK);
		} else {
			helperText = getLabel(config?.EmailErrorText);
		}
	} else if (forgotPasswordError) {
		helperText = getLabel(config?.HELPER_TEXT_EMAIL_NF);
	}



	if (config) {
		return (
			<Box mt="144px" id="forgot-password-page">
				<Header screenType="forgotpassword" id="forgot-password-header-component"/>
				    <Box sx={{ mt: "97px" }}>
						<div className="container-home" id="forgot-password-container">
							<Box textAlign="center">
								<img className="image-login" src={password} alt="logInIcon" width="57" height="56" id="forgot-password-image"/>
							<Typography className="heading-1" sx={{ mt: "20px" }} data-testid="forgot_pass_header" id="forgot-password-title">
									{getLabel(config.FORGET_PASSWORD)}
								</Typography>
							<Typography className="subtext-cards" sx={{ mt: "24px" }} data-testid="forgot_pass_header_label" id="forgot-password-subtitle">
									<FXCMTrans
										defaults={getLabel(config.FORGOT_PASSWORD_LABEL)}
									/>
								</Typography>
							</Box>
							<form id="forgot-password-form">
								<FormControl
									fullWidth
									sx={{ mt: "20px" }}
									 className={formControlClass}
									 id="email-form-control"
								>
									<TextField
										value={values.email}
										onChange={handleChange("email")}
										inputProps={{ maxLength: 50 }}
										onBlur={handleBlurEmail}
										name="email"
										error={!!error.email}
										helperText={helperText}
										label={getLabel(config.EMAIL)}
									/>

								</FormControl>

								<FormControl className="forgotChekbox" id="email-checkbox-control">
									<FormControlLabel 
										control={
											<Checkbox checked={values.isChecked} size="small" />
										}
										onChange={handleLabelChange}
										label={getLabel("EMAIL_ADDRESS_LABEL")}
									/>
								</FormControl>

								<FormControl
									fullWidth
									sx={{ mt: "20px" }}
									className={
										direction.status
											? "custom-form-controler custom_form_controler_arabic"
											: "custom-form-controler"
									}
									id="username-form-control"
								>
									<TextField
										value={values.username}
										onChange={handleChange("username")}
										inputProps={{ maxLength: 50 }}
										onBlur={handleBlurUsername}
										error={error.username ? true : false}
										helperText = {error.username  && mandatoryError ? getLabel(config.MANDATORY_CHECK) : ""}
										// helperText={
										// 	error.username
										// 		? fxcmError
										// 			? getLabel(config.UserErrorText)
										// 			: mandatoryError.username
										// 			? getLabel(config.MANDATORY_CHECK)
										// 			: getLabel(config.INVALID_EMAIL_SUBTITLE)
										// 		: ""
										// }
										label={getLabel(config.USERNAME)}
									/>
								</FormControl>

								<Box sx={{ mt: 3 }}>
									{countryBlocked && countryBlockedMessage && (
										// `error` kept in step with the login and forgot-username screens
										// so all three render the same red-on-pink error box.
										<FormControl error fullWidth className={direction.status ? "custom-form-controler custom_form_controler_arabic" : "custom-form-controler"}>
											<FormHelperText id="forgot-password-country-blocked">
												<FXCMTrans 
													defaults={countryBlockedMessage}
													values={{country: blockedCountryCode, lang: languageParam?.split("-")[0]}}
												></FXCMTrans>
											</FormHelperText>
										</FormControl>
									)}

									<Grid
										container
										spacing={1}
										className={
											direction.status
												? "forgot-button_Arabic"
												: "forgot-button"
										}
										id="forgot-password-button-group"
									>
										<Grid item xs={6}>
											<Button
												fullWidth
												variant="outline"
												sx={{ my: 1 }}
												onClick={handleCancelClick}
												id="cancel-button"
											>
												{getLabel("CANCEL")}
											</Button>
										</Grid>
										<Grid item xs={6}>
											<LoadingButton
												loading={buttonLoader}
												loadingPosition="end"
												type="submit"
												disabled={enabled}
												fullWidth
												sx={{ mt: 1 }}
												variant="contained"
												onClick={handleSubmit}
												id="submit-button"
											>
												{getLabel("SUBMIT")}
											</LoadingButton>
										</Grid>
									</Grid>
								</Box>
								<Typography
									textAlign="center"
									sx={{ mt: 3 }}
									className="support-text"
								data-testid="forgot_pass_support"
								id="forgot-password-support-text"
								>
									{getLabel("SUPPORT_TEXT")}
									<span>
									<a href={`${link}`} 
									onClick={(e)=>{
										analytics?.trackEvent("targeted_click",{engagementContext:"fxcm_support"});
									}
									  }
									target="_blank" 
									rel="noopener noreferrer" id="fxcm-support-link">
										{getLabel("FXCM_SUPPORT")}
									</a>
									</span>
								</Typography>
							</form>
						</div>
					</Box>
			</Box>
		);
	}
};

export default ForgotPassword;
